import { useQuery } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

export function useLocalEvents() {
  return useQuery({
    queryKey: ['marketplace', 'events'],
    queryFn: marketplaceService.getLocalEvents,
    staleTime: 10 * 60 * 1000,
  });
}
